export default function incCount(acc, key, by = 1) {
  if (!key) key = '';
  key = key.trim();
  if (acc[key]) return setKey(acc, key, acc[key] + by);

  // Fallback: search for key, ignoring the casing.
  const lowerCaseKey = key.toLowerCase();

  const [foundKey, value] =
    Object.entries(acc).find(([key]) => key.toLowerCase() === lowerCaseKey) ||
    [];
  if (foundKey !== undefined) return setKey(acc, foundKey, value + by);
  return setKey(acc, key, by);
}

function setKey(acc, key, value) {
  acc[key] = value;
  return acc;
}
